import { render, staticRenderFns } from "./Category-Item.vue?vue&type=template&id=15e7c23c&"
import script from "./Category-Item.vue?vue&type=script&lang=ts&"
export * from "./Category-Item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports